module.exports = __webpack_public_path__ + "img/dirndl-stine-70-cm–pink.268cd073.png";